import { createElement } from 'react'
import { BaseControl } from 'react-map-gl'

class MarkerCSSTransformed extends BaseControl {
  // Swtiched to CSS transforms
  // Adapted from https://github.com/rshtg/react-map-gl/blob/3a9187d6b50beb84b39926eb2b28d248d8241182/src/components/marker.js
  _render() {
    const {
      className,
      longitude,
      latitude,
      offsetLeft,
      offsetTop,
      style,
    } = this.props

    const [x, y] = this._context.viewport.project([longitude, latitude])

    const { left, top } = {
      left: Math.round(x + offsetLeft),
      top: Math.round(y + offsetTop),
    }

    let containerStyle = {}

    containerStyle = {
      transform: `translate3d(${left}px, ${top}px, 0)`,
      ...style,
    }

    return createElement('div', {
      className: ['mapboxgl-marker', className].filter(x => x).join(' '),
      ref: this._onContainerLoad,
      style: containerStyle,
      children: this.props.children,
    })
  }
}

export default MarkerCSSTransformed
